import {
  Body,
  Box,
  Button,
  Space,
  useIsMobileLayout,
} from "@dbn/omnichannel-design-system-g4p";
import { ArrowRightIcon } from "@g4p/react-styleguide-library";
import { useFormatMessage } from "../../intl";
import { DocumentMeta } from "../documentAPI";
import { DocumentDialog } from "./DocumentDialog";
import { useState } from "react";

type Props = {
  document: DocumentMeta;
};

export function DocumentListItem(props: Props) {
  const isMobileLayout = useIsMobileLayout();
  const formatMessage = useFormatMessage();
  const [showContractModal, setShowContractModal] = useState(false);

  return (
    <>
      <Box column={isMobileLayout} hAlignContent={"left"}>
        <Box width={"80%"}>
          <Body size="medium" weight="regular">
            {props.document.docTitle}
          </Body>
        </Box>
        <Space units={2} />
        <Button
          variant="text"
          ariaLabel={formatMessage("Documents.openDocument.ariaLabel")}
          label={formatMessage("Documents.openDocument")}
          size="default"
          action={() => setShowContractModal(true)}
          rightContent={<ArrowRightIcon style={{ width: 14, height: 14 }} />}
        />
      </Box>
      {showContractModal && (
        <DocumentDialog
          document={props.document}
          handleDismiss={() => setShowContractModal(false)}
          sealed={false}
        />
      )}
    </>
  );
}
